import React from 'react';
import { classes } from '../../services/utils';
import './TableContainer.scss';

const TableContainer: React.FC<{ className?: string }> = ({ className, children }) => {
    return <div className={classes('table-container', { [className || '']: !!className })}>{children}</div>;
};

export default TableContainer;
